import { Article, DocsHeader, DocsHeading, DocsIntro, Image, Section, SectionHeader } from "../extra/Components";

import uthopp from '../assets/4 hoppet/3 uthopp-small.jpg';
import uthopp_small from '../assets/4 hoppet/3 uthopp-small.jpg';
import spotting from '../assets/4 hoppet/2 spotting-small.jpg';
import spotting_small from '../assets/4 hoppet/2 spotting-small.jpg';
import dorren from '../assets/4 hoppet/5 i dörren-small.jpg';
import dorren_small from '../assets/4 hoppet/5 i dörren-small.jpg';
import banan from '../assets/4 hoppet/2 banan2-small.jpg';
import banan_small from '../assets/4 hoppet/2 banan2-small.jpg';
import heading from '../assets/4 hoppet/6 heading-small.jpg';
import heading_small from '../assets/4 hoppet/6 heading-small.jpg';
import bra from '../assets/5 aff/tecken/bra-small.jpg';
import bra_small from '../assets/5 aff/tecken/bra-small.jpg';
import hojd from '../assets/5 aff/tecken/höjd-small.jpg';
import hojd_small from '../assets/5 aff/tecken/höjd-small.jpg';
import boj from '../assets/5 aff/tecken/böj-small.jpg';
import boj_small from '../assets/5 aff/tecken/böj-small.jpg';
import ihop from '../assets/5 aff/tecken/ihop-small.jpg';
import ihop_small from '../assets/5 aff/tecken/ihop-small.jpg';
import strack from '../assets/5 aff/tecken/sträck-small.jpg';
import strack_small from '../assets/5 aff/tecken/sträck-small.jpg';
import svanka from '../assets/5 aff/tecken/svanka-small.jpg';
import svanka_small from '../assets/5 aff/tecken/svanka-small.jpg';
import slappnaAv from '../assets/5 aff/tecken/slappna av-small.jpg';
import slappnaAv_small from '../assets/5 aff/tecken/slappna av-small.jpg';
import dra from '../assets/5 aff/tecken/dra-small.jpg';
import dra_small from '../assets/5 aff/tecken/dra-small.jpg';
import drag from '../assets/4 hoppet/4 drag-small.jpg';
import drag_small from '../assets/4 hoppet/4 drag-small.jpg';
import kompensering from '../assets/4 hoppet/8 dragkompensering2-small.jpg';
import kompensering_small from '../assets/4 hoppet/8 dragkompensering2-small.jpg';
import hittaHandtaget from '../assets/4 hoppet/9 hitta handtaget-small.jpg';
import hittaHandtaget_small from '../assets/4 hoppet/9 hitta handtaget-small.jpg';
import delta from '../assets/4 hoppet/7 moln/8 delta-small.jpg';
import delta_small from '../assets/4 hoppet/7 moln/8 delta-small.jpg';

import spottingFaltet from '../assets/4 hoppet/12 spotting faltet-small.jpg';
import spottingKlocka from '../assets/4 hoppet/13 spotting klocka-small.jpg';

import {
    faExclamation,
    faExclamationTriangle,
    faTachometerAlt,
} from "@fortawesome/free-solid-svg-icons";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Question, Questionary } from "../extra/Quiz";
import Alti from "./Alti";
import { Link } from "react-router-dom";

const hoppetQuiz = [
    Question.oneQ("Vem ansvarar för att jag hoppar ut på rätt ställe?", "Jag själv men under kursen instruktörerna", ["Alltid jag själv", "Piloten", "Förste hoppare", "Mest erfarna hoppare i liften"]),
    Question.order("På 1800 m gör jag", ["Vink", "Svank", "Ta", "Dra"]),
    Question.oneQ("Befinner jag mig på 650m i frifall bör jag omedelbart", "Dra min reserv", ["Dra min fallskärm", "Dubbelkolla höjden", "Titta var min instruktör tagit vägen"]),
    Question.oneQ("På vilken höjd får jag dragtecken av min instruktör om jag inte påbörjat mitt drag?", "1499m", ["1500m", "1200m", "1800m", "700m", "1100m"]),
    Question.oneQ("På vilken höjd ska jag påbörja mitt drag?", "1800m", ["1799m", "1200m", "1500m", "700m", "1100m"]),
    Question.oneQ("På vilken höjd ska jag sluta göra övningar från mitt program och fokusera på höjden för att dra?", "1800m", ["1499m", "1200m", "1500m", "700m", "1100m"]),
    Question.oneQ("En key är:", "Rörelse som timear att alla hoppar av samtidigt. Signalerar ut, in, hopp i tempo", ["Nyckel på engelska", "samma som hotellcheck", "Att man format sig som en nyckel efter uthoppet."]),
    Question.oneQ("Råkar vi falla genom ett moln så", "Fortsätter jag mitt program", ["Pausar mitt program", "Drar min fallskärm", "Drar inte min fallskärm"]),
];


const hoppetSpotting = <Section id="spotting" name="Spotting">
    <SectionHeader>Spotting</SectionHeader>

    <Image image={spotting} imageSmall={spotting_small} alt="Spotting" />

    <p>Innan man hoppar av bör man försäkra sig om att man är på rätt ställe. Spotting är namnet
        på att identifiera över vilken punkt man ska hoppa av. Från engelskans spot. Flygplanet
        flyger i motvind när vi hoppar av och därav är den ideella uthoppspunkten en bit förbi
        där man vill landa. Hur långt förbi beror på vindstyrkan. Instruktörerna kommer stå för den
        bedömningen de första hoppen. Det är viktigt att ha koll på när det närmar sig att hoppa
        av. Delvis för att se till att sin utrustning är redo men också för att se att
        flygplanet är på rätt kurs och plats inför uthoppspunkten. När man tittar ner i dörren
        ska det vara för att bekräfta man är på rätt plats och det inte är andra flygplan
        nedanför. Inte för att klura ut var man är.</p>
    <p>För att hjälpa till sitter en lampa längst bak i flygplanet som piloten kontrollerar. Två
        minuter innan grön lampa tänder piloten rött ljus. Man gör en sista check. Därefter
        skiftar lampan till gult. Då öppnas dörren. Det är ca 20 sekunder kvar till grönt. Grönt
        tänds när piloten bedömer att vi är på rätt plats för den första gruppen att hoppa ut.
        Man får hoppa på gult och man måste inte hoppa på grönt. Piloten ger sitt förslag men
        man är alltid själv ansvarig för var man hoppar av.</p>
    <Image image={spottingFaltet} />
    <p>Ungefär så här ser det ut när man tittar ut genom dörren. Hoppfältet är mitt i med cirkeln och landningsbanan synlig.
        Det kan vara svårt att se exakt vad som är rakt ner men det övar man på.</p>
    <p>Lär dig känna igen geografin runt fältet så att du kan titta ut ur planet
        och veta om det är på väg mot eller bort från fältet.</p>
    <Image image={spottingKlocka} />
    <p>Man kan såklart använda hjälpmedel för att spotta och de kan vara trevliga men 
        ibland hoppar de fel och det är alltid bäst att dubbelkolla innan man hoppar av.
         Man kan inte skylla på någon annan om man väljer att hoppa av flygplanet på fel plats.</p>

</Section>;

const hoppetHeading = <Section id="heading" name="Heading">
    <SectionHeader>Heading</SectionHeader>

    <Image image={heading} imageSmall={heading_small} alt="Heading" />

    <p>Heading, kurs innebär en mål på horisonten man använder som referens för att ligga stilla
        utan att rotera. I frifall ligger man inte still still automatiskt utan måste hela tiden
        hålla kolla på en heading och styra emot störningar som blir. Ska man göra ett moment med
        framåtåkning så tar man en heading man siktar på och styr tillbaka mot när man driver av. Om
        instruktören vill att man ska svänga så får man en ny heading.
    </p>
    <p>
        Man kan använda vad som helst som står still som heading. Ett moln på horisonten, solen, en
        stad eller eventuellt en instruktör ifall man gör ett moment där instruktören ligger still.
    </p>
</Section>;

const hoppetMoln = <Section id="hoppmoln" name="Moln i frifall">
    <SectionHeader>Moln i frifall</SectionHeader>

    <Image image={delta} imageSmall={delta_small} alt="Dra din fallskärm" />

    <p>Huvudregeln är att vi inte hoppar genom moln. Vi vill kunna se att det är fritt från hinder
        nedanför oss och att vi är på rätt ställe. Instruktören kan bestämma både på marken och i
        flygplanet att det är för mycket moln för att genomföra elevhoppning. Efter kursen gäller
        eget ansvar men hoppar man genom moln kan HL skälla på en. Bästa är att inse det är för
        mycket moln på marken.</p>
    <p>Hamnar man mot förmodan i moln under sina aff hopp fortsätter man sitt program och följer
        tecken från instruktören. Håll extra noga koll på höjden!</p>
</Section>;

const frifalletsPri = <>
    <ol>
        <li><strong>Dra</strong>, din fallskärm</li>
        <li><strong>Dra, på rätt höjd</strong></li>
        <li><strong>Dra, stabilt</strong></li>
    </ol>

    <p>Dessa prioriteringar går före allt i frifall och är i ordning. Att dra fallskärmen går
        före ifall man inte skulle vara stabil på draghöjd.</p>
</>

const hoppetDrag = <Section id="drag" name="Drag">
    <SectionHeader>Drag</SectionHeader>

    <Image image={drag} imageSmall={drag_small} alt="Dra din fallskärm" />

    <p>Draget avslutar fallskärmen och ger förutsättningar för att den ska öppnas korrekt. Draget
        består utav fyra plus en rörelser i sekvens:</p>
    <ol>
        <li><strong>Vink</strong>, korsa armarna en gång för att signalera till hoppare i närheten
            att du har för avsikt att dra din fallskärm.</li>
        <li><strong>Svank</strong>, skjut fram höften för att extra stabilitet i draget.</li>
        <li><strong>Ta</strong>, hitta och greppa pilothandtaget säkert med hela handen. Andra armen
            tar man fram framför sig för att kompensera balansen.</li>
        <li><strong>Dra</strong>, kasta ut piloten i en bestämd rörelse.</li>
        <li><strong>Flyg</strong>, återgå till frifallsposition och flyg din kropp till att
            fallskärmen tar över.</li>
    </ol>
    <p>Efter man har kastat piloten så påbörjar man kallotdrillen som kommer i nästa kapitel.</p>

    <Image image={kompensering} imageSmall={kompensering_small} alt="Kompensera drag" />

    <p>På bilden ovan ser vi ett exempel på att när man tar bak ena armen för att dra så måste andra
        armen fram för att kompensera så man inte välter åt sidan.</p>

    <h3>Hitta handtaget</h3>

    <Image image={hittaHandtaget} imageSmall={hittaHandtaget_small} alt="Hitta handtaget" />

    <p>För att kunna dra sin fallskärm behöver man hitta sitt pilothandtag. Man över på marken men
        riggen skiftar runt lite i frifall. Man sträcker sig bak och känner efter den. Träffar man
        sitt ben följer man benet upp till riggen och hittar handtaget. Hittar man riggen följer man
        den ner till handtaget. Man ger det två försök och efter det om man är på draghöjd genomför
        man reservdragsprocedur. Där ser man handtagen man ska greppa.</p>
</Section>;

const hoppetAff1 = <Section id="aff1intro" name="Aff 1">
    <SectionHeader>AFF 1</SectionHeader>
    <p></p>
    <ol>
        <li><strong>Hotellcheck</strong>, check in, check ut</li>
        <li><strong>Key</strong>, ut, in, ut</li>
        <li><strong>Uthopp</strong>, hoppa ut med instruktörerna</li>
        <li><strong>Svanka</strong>, bli stabil i frifall</li>
        <li><strong>Heading</strong>, riktning på horisonten</li>
        <li><strong>Höjd</strong>, se vad den är</li>
        <li><strong>Instruktör till vänster</strong>, få tecken, gör som instruerat fram till tumme
            upp</li>
        <li><strong>Instruktör till höger</strong>, få tecken, gör som instruerat fram till tumme
            upp</li>
        <li><strong>3 st dummy drag</strong>, känner på pilothandtaget så man vet var det finns
            inför drag</li>
        <li><strong>Heading</strong>, riktning på horisonten</li>
        <li><strong>Höjd</strong>, se den hoppet kan vara slut här</li>
        <li><strong>Kolla vänster</strong>, få tecken</li>
        <li><strong>Kolla höger</strong>, få tecken</li>
        <li><strong>2000m</strong>, lock on</li>
        <li><strong>1800m</strong>, drag</li>
    </ol>
    <p>Att titta på horisont, höjd, vänster, höger gör att man nästan för huvudet i en cirkel.
        Tillsammans kallas en sådan sekvens för Observationscirkel.</p>
</Section>;

const hoppetTecken = <Section id="tecken" name="Tecken">
    <SectionHeader>Tecken</SectionHeader>
    <p>
        Det går inte att prata i frifall så för att kommunicera använder vi oss av olika handtecken
        för att ge instruktioner.
    </p>
    <h3>Bra, fortsätt</h3>

    <Image image={bra} imageSmall={bra_small} alt="Bra, fortsätt" />

    <p>Betyder ofta fortsätt i ditt program</p>
    <h3>Kolla din höjdmätare</h3>

    <Image image={hojd} imageSmall={hojd_small} alt="Kolla din höjdmätare" />

    <p>Används för att uppmärksamma på höjden. Om man inte tydligt visar att man kollar höjden efter
        2000m så kommer man få detta tecken från sin instruktör</p>
    <h3>Böj på benen</h3>

    <Image image={boj} imageSmall={boj_small} alt="Böj på benen" />

    <p>Böj benen i knät bakåt. </p>
    <h3>Ihop med benen</h3>

    <Image image={ihop} imageSmall={ihop_small} alt="Ihop med benen" />

    <p>För knäna närmare varandra. </p>
    <h3>Sträck på benen</h3>

    <Image image={strack} imageSmall={strack_small} alt="Sträck på benen" />

    <p>Spänn låren och för nedre benen framåt.</p>
    <h3>Svanka</h3>

    <Image image={svanka} imageSmall={svanka_small} alt="svanka" />

    <p>För höften framåt</p>
    <h3>Slappna av</h3>

    <Image image={slappnaAv} imageSmall={slappnaAv_small} alt="Slappna av" />

    <p>Används om man är väldigt spänd i frifall. Andetag, le och fortsätt.</p>
    <h3>Dra din fallskärm</h3>

    <Image image={dra} imageSmall={dra_small} alt="Dra din fallskärm" />


    <p>Ett kommando att omedelbart påbörja sin drag sekvens.</p>

    <div className="callout-block callout-block-warning">
        <div className="content">
            <h4 className="callout-title">
                <span className="callout-icon-holder me-1">
                    <FontAwesomeIcon icon={faExclamation} style={{ color: 'black', height: '20px', width: '20px' }} />
                </span>
                Dra din fallskärm
            </h4>
            <p>Din instruktör tar tag i din hand och för den mot pilothandtaget.</p>
        </div>
    </div>
    <div className="callout-block callout-block-info">
        <div className="content">
            <h4 className="callout-title">
                <span className="callout-icon-holder me-1">
                    <FontAwesomeIcon icon={faExclamation} style={{ color: 'black', height: '20px', width: '20px' }} />

                </span>
                Du skulle dragit din fallskärm.
            </h4>
            <p>Drar du inte din fallskärm och instruktörer har möjlighet kommer de att dra din
                fallskärm. Oftast innebär det ett underkänt hopp.</p>
        </div>
    </div>
    <div className="callout-block callout-block-danger me-1">
        <div className="content">
            <h4 className="callout-title">
                <span className="callout-icon-holder">
                    <FontAwesomeIcon icon={faExclamationTriangle} style={{ color: 'black', height: '20px', width: '20px' }} /> &nbsp;
                </span>
                Dra din fallskärm omedelbart
            </h4>
            <p>Din instruktör drar sin egen fallskärm. Det är den sista signalen du kommer få att du
                omedelbart bör dra din fallskärm.</p>
        </div>
    </div>
</Section>;

const hoppetUthopp = <Section id="uthopp" name="Uthopp">
    <SectionHeader>Uthopp</SectionHeader>

    <Image image={dorren} imageSmall={dorren_small} alt="I dörren" />

    <p>Bilden ovan visar en instruktör utanför, en elev i dörren och är ur perspektivet av
        instruktören innanför inför ett uthopp med två instruktörer.</p>
    <p>Uthoppet är starten på frifallet. Att komma ut synkat och stabilt med sina instruktörer är
        att ge sig själv lättare förutsättningar för ett lyckat frifall. processen börjar med att
        uthoppspunkten spottas utav instruktören. Därefter får eleven kommandot "i dörren". Eleven
        ställer sig redo i dörren och gör en hotellcheck. Checkar in med instruktören innanför och
        därefter checkar med instruktören utanför. Med klarsignal från båda genomför eleven en
        <b>key</b>. En key är en signal för att synkronisera uthopp. För de första aff hoppen består
        det
        av att man med armarna för de ut, in och i takt med en tredje rörelse kliver ut i lufthavet.
        Väl i frifall vill man skjuta fram höften och forma kroppen som en banan med magen mot
        fartvinden.
    </p>
    <h3>"Svank" för frifall</h3>

    <Image image={banan} imageSmall={banan_small} alt="Frifallsställning" />

    <br />
    <h3>Uthoppsramsa</h3>
    <p>
        Föregående stycke kan sammanfattas i den här listan
    </p>
    <ul>
        <li>Dörren öppnas.</li>
        <li>Instruktören visar var du ska sitta.</li>
        <li>Instruktören spottar.</li>
        <li>Instruktören tar tag i selen på din rigg.</li>
    </ul>
    <ol>
        <li><strong>I dörren</strong>, svara "i dörren" och ställ dig i uthoppsställning</li>
        <li><strong>Check in</strong>, titta in, få tumme upp av instruktören inne</li>
        <li><strong>Check ut</strong>, titta utåt, få ett skak av instruktören ute</li>
        <li><strong>Ut, in, hopp</strong>, key</li>
        <li><strong>Svanka</strong>, höften framåt kroppen bananformad, magen mot fartvinden.</li>
    </ol>
    <p>Check in, checkout kallas tillsammans för hotellcheck.</p>
</Section>;


const hoppetHojd = <Section id="hojd" name="Höjd">
    <SectionHeader>Höjd</SectionHeader>
    <p>I frifall finns det en sak som går före allt annat. Höjden. Frifall till drag från 3200m till
        1800m varar i lite mer än 35 sekunder. Frifallshastigenheten är för de flesta mellan 180 och
        210 kilometer i timmen. Nedan kan du se hur lång tid det tar för höjdmätaren att räkna ner.
        För alla hopp under utbildningen är draghöjden 1800m. Det är viktigt att när man kolla på
        höjdmätaren att man repeterar höjden för sig själv högt. Ett vanligt sätt att bli underkänd
        är att titta på höjdmätaren utan att se höjden och inte dra sin fallskärm i tid.</p>

    <h2>Höjdmätare</h2>
    <Alti startingHeight={3900} width={400} />
    <Link to="/altimiter">Bara höjdmätare</Link>
    <br />
    <br />
    <h3>Lock on</h3>
    <p>Från engelska, lås fast. I och med att vår prioritering predikar höjd framför allt så är lock
        on att när man ser att man närmar sig draghöjd så håller man kvar blicken på höjdmätaren.
        Under aff-programmet så ska man hålla kvar blicken på höjdmätaren om man är på eller under
        2000 m.</p>
    <h3>Instruktörerna och höjd</h3>
    <p>Under utbildningen är lock on höjden 2000m och draghöjden 1800m förutom sista hoppet där vi
        hoppar av under 1500m. Detta innebär att om du inte tydligt visar att du kollar på
        höjdmätaren kommer du få ett kolla höjden tecken mellan 2000m och 1800m. Påbörjar du inte
        ditt drag på 1800m kommer du få ett dra din fallskärm tecken på 1799m. Reagerar du inte det
        tecknet kommer instruktören försöka dra dig i armen för att tvinga dig dra. Har fallskärmen
        inte
        dragits på 1500m kommer instruktören dra din fallskärm. Blir instruktören tvungen att dra
        din
        fallskärm är hoppet sannolikt underkänt. Är instruktören inte där blir det ännu viktigare
        att dra sin egen fallskärm i tid.</p>
    <h3>Vilken fallskärm beroende på höjd</h3>
    <p>Under utbildning kommer vi dra vår fallskärm på 1800m. Senare under sin fallskärmskarriär
        efter erfarenhet kan det sänkas till en draghöjd på 1000m. Den lägsta höjd det är tillåtet
        att lösa ut sin huvudfallskärm är <b>700m</b>. Definierat som när sprinten lämnar loopen.
        Befinner vi oss under 700m i frifall är vi i en nödsituation och bör omedelbart dra våran
        reserv. Anledningen att vi inte drar vår huvudfallskärmen under den höjden är för att vi
        använt upp höjden vi skulle behövt för att dra våran huvudfallskärm identifiera fel och
        därefter dra våran reserv och måste då hoppa till slutet och använda reserven "preventivt".
        Beroende på hur långt under 700m vi är har vi också nytta utav att reservfallskärmen öppnar
        snabbare än huvudfallskärmen. Det finns ingen lägsta tillåtna höjd att agera och man bör i
        varje ögonblick göra allt för att öka sina chanser att överleva. </p>
    <h3>Hög höjd</h3>
    <p>Desto högre upp man är desto tunnare blir luften och desto mindre syre får man i sig. Detta
        innebär att är man på hög höjd längre stunder kommer man få syrebrist och börja prestera
        sämre mentalt, så kallat hypoxi. För att undvika att hoppare upplever hypoxi begränsas tiden
        man får spendera över 3000 m utan extra syrgas till 30 minuter. Över 4000 m ska syrgas
        användas från början.</p>
</Section>;

const hoppetQuizSection = <Section id="hoppet-quiz" name="Quiz">
    <SectionHeader>Quiz, hoppet</SectionHeader>
    <Questionary
        questions={hoppetQuiz} />
</Section>;
const Hoppet =
    ({ setSection, setArticle }) =>
    (
        <Article name="Hoppet" icon={faTachometerAlt} id="hoppet" setArticle={setArticle} setSection={setSection}>
            <DocsHeader>
                <DocsHeading note="Updaterad: 2022-07-13">Hoppet</DocsHeading>
                <DocsIntro>
                    <Image image={uthopp} imageSmall={uthopp_small} alt="Uthopp" />

                    <p>Frifallet är den centrala delen i fallskärmshoppning. Den har tre stycken huvudregler:</p>
                    {frifalletsPri}
                </DocsIntro>
            </DocsHeader>
            {hoppetSpotting}
            {hoppetUthopp}
            {hoppetHeading}
            {hoppetHojd}
            {hoppetAff1}
            {hoppetTecken}
            {hoppetDrag}
            {hoppetMoln}
            {hoppetQuizSection}
        </Article>
    );

export {
    Hoppet, hoppetQuiz, frifalletsPri, hoppetHojd, hoppetDrag, hoppetUthopp, hoppetTecken, hoppetAff1,

    hoppetSpotting,
    hoppetHeading,
    hoppetMoln,
    hoppetQuizSection
};